import api from "@/assets/js/api"; // 假設 API 模組存在
import axios from "axios"; // 確保 axios 被導入
import Swal from "sweetalert2"; // 引入 SweetAlert2 套件

export default {
  name: "RegisterPage",
  data() {
    return {
      formData: {
        email: "",
        password: "",
        confirmPassword: "",
        fullname: "",
        country: "",
        phone: "",
        dob: "",
      },
      today: "", // 儲存今天的日期
      countries: [], // 儲存國家列表
      passwordValidationMessage: "", // 密碼驗證訊息
      passwordsMatch: true, // 密碼是否一致
    };
  },
  methods: {
    setToday() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // 月份補 0
      const dd = String(today.getDate()).padStart(2, "0"); // 日期補 0
      this.today = `${yyyy}-${mm}-${dd}`;
    },

    async fetchCountryList() {
      try {
        const url = "https://restcountries.com/v3.1/all?fields=name,cca2"; // 指定只取 name 和 cca2 欄位
        const response = await axios.get(url); // 發送 GET 請求

        this.countries = response.data
          .map((country) => {
            const nativeName = country.name?.nativeName;
            const zhName = nativeName?.zho?.common; // 取出中文名稱（簡體）

            return {
              name: zhName || country.name.common, // 優先使用中文名稱，沒有就 fallback 英文
              code: country.cca2, // 國家代碼
            };
          })
          .filter((c) => c.name && c.code) // 過濾空值
          .sort((a, b) => a.name.localeCompare(b.name, "zh-Hant")); // 中文排序
      } catch (error) {
        console.error("無法加載國家列表", error);

        Swal.fire({
          icon: "error",
          title: "載入失敗",
          text: "載入國籍列表失敗，請稍後再試！",
        });
      }
    },
    validatePasswords() {
      if (!this.formData.confirmPassword) {
        this.passwordValidationMessage = "";
        this.passwordsMatch = true;
        return;
      }
      if (this.formData.password === this.formData.confirmPassword) {
        this.passwordValidationMessage = "密碼一致！";
        this.passwordsMatch = true;
      } else {
        this.passwordValidationMessage = "密碼不一致，請檢查！";
        this.passwordsMatch = false;
      }
    },

    async handleRegister() {
      // 驗證密碼一致性
      if (this.formData.password !== this.formData.confirmPassword) {
        // 密碼與確認密碼不一致時提示
        Swal.fire({
          icon: "warning",
          title: "密碼不一致",
          text: "密碼與確認密碼不一致！",
        }); // 顯示 SweetAlert2 警告提示

        return;
      }

      // 組裝 payload
      const payload = {
        Email: this.formData.email.trim(),
        PasswordHash: this.formData.password.trim(), // 密碼
        FullName: this.formData.fullname.trim(),
        Countries: this.formData.country.trim(),
        Phone: this.formData.phone.trim(),
        Birth: new Date(this.formData.dob).toISOString(),
      };

      console.log("發送的 payload：", payload);

      try {
        const response = await api.post("/Login/register", payload);
        if (response.data.success) {
          // 註冊成功提示
          Swal.fire({
            icon: "success",
            title: "註冊成功！",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$router.push("/login"); // 提示後導頁
          }); // 顯示 SweetAlert2 成功提示並導頁

         
        } else {
          // 註冊失敗時提示
          Swal.fire({
            icon: "error",
            title: "註冊失敗",
            text: response.data.message || "註冊失敗！",
          }); // 顯示 SweetAlert2 錯誤提示
        }
      } catch (error) {
        if (error.response) {
          console.error("伺服器返回錯誤", error.response.data);
          if (error.response.status === 409) {
            // 信箱已被註冊
            Swal.fire({
              icon: "warning",
              title: "信箱已被使用",
              text: error.response.data.message || "此信箱已被註冊！",
            }); // 顯示 SweetAlert2 警告提示
          } else {
            // 伺服器錯誤
            Swal.fire({
              icon: "error",
              title: "伺服器錯誤",
              text: error.response.data.message || "伺服器錯誤，請稍後再試！",
            }); // 顯示 SweetAlert2 錯誤提示
          }
        } else if (error.request) {
          console.error("未收到伺服器回應", error.request);
          // 未收到伺服器回應
          Swal.fire({
            icon: "error",
            title: "連線錯誤",
            text: "無法連接伺服器，請檢查網路或稍後再試！",
          }); // 顯示 SweetAlert2 錯誤提示
        } else {
          console.error("請求設置錯誤", error.message);
          // 其他未知錯誤
          Swal.fire({
            icon: "error",
            title: "未知錯誤",
            text: "發生未知錯誤，請稍後再試！",
          }); // 顯示 SweetAlert2 錯誤提示
        }
      }
    },
  },

  created() {
    this.setToday(); // 初始化時設定今天的日期
    this.fetchCountryList(); // 初始化時加載國家列表
  },
};
